/* hgn-side-cart-drop.js — moved verbatim from snippets/hgn-side-cart-drop.liquid on 2026-09-14 (page-weight:
   inline JS → theme asset, loaded synchronously at the same position so execution order
   and DOMContentLoaded timing are unchanged). EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';
  if (window.__hgnSideCartDropBooted) return;
  window.__hgnSideCartDropBooted = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  }

  ready(function () {
    var listEl = document.querySelector('[data-hgn-side-cart-drop-list]');
    if (!listEl) return;

    var DROP_TIERS = ['classic', 'gels', 'press-ons'];
    /* Lane names — match the entry modal (R4: always "Nail Drop"). */
    var TIER_LABEL = {
      classic:     'Classic Nail Drop',
      gels:        'Gel Nail Drop',
      'press-ons': 'Press-On Nail Drop'
    };
    var LANE_NOUN = {
      classic:     'Classic Wraps',
      gels:        'Gel Wraps',
      'press-ons': 'Press-On sets'
    };
    var DEFAULT_COUNTS = { classic: 4, gels: 3, 'press-ons': 2 };

    /* Concertina state survives renders — mirror of kit-build's
       manualOpen. Single section, so a plain string. */
    var manualOpen = null; // 'open' | 'closed' | null (default open)
    var stockMap = {};     // variantId → { inStock, quantity } (last stock-check)
    /* Audit D1: the same design sitting in the drop queue AND as a
       paid cart line read as a bug to the auditors — track cart
       variant ids so queue rows can explain the double-presence. */
    var cartVariantIds = {};
    var cartLinesFetched = false;
    function adoptCartLines(cart) {
      cartVariantIds = {};
      ((cart && cart.items) || []).forEach(function (li) {
        if (li && li.variant_id != null) cartVariantIds[String(li.variant_id)] = true;
      });
    }
    function ensureCartLines() {
      if (cartLinesFetched) return;
      cartLinesFetched = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) { adoptCartLines(c); render(); } })
        .catch(function () {});
    }
    /* Fix F4: sync-local's lane-integrity skip count — sticky for the
       page lifetime so the shopper learns why saved designs are
       missing from the merged queue. */
    var tierRejectedNotice = 0;

    function dq() { return (window.HGN && window.HGN.dropQueue) ? window.HGN.dropQueue : null; }
    function sm() { return (window.HGN && window.HGN.shopMode) ? window.HGN.shopMode : null; }
    function dropAvailable() {
      var s = sm();
      return !!(s && typeof s.isDropAvailable === 'function' && s.isDropAvailable());
    }
    function dropModeOn() {
      var s = sm();
      return !!(s && typeof s.get === 'function' && s.get() === 'drop');
    }
    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
    function dropCopy(key, fallback) {
      var c = window.HGN_DROP_COPY || {};
      var v = c[key];
      return (v == null || v === '') ? fallback : v;
    }
    function tierCount(tier) {
      var m = window.HGN_DROP_COUNTS || DEFAULT_COUNTS;
      var n = parseInt(m[tier], 10);
      return (isFinite(n) && n > 0) ? n : (DEFAULT_COUNTS[tier] || 4);
    }
    function wizardUrl() {
      var urls = window.HGN_DROP_URLS || {};
      return urls.wizard || '/pages/nail-drop';
    }
    function browseUrl() {
      var canon = window.HGN_CANONICAL_COLLECTIONS || {};
      /* Prefer the locked lane's collection — the tier lock means
         only lane designs can join, so that's where to send them. */
      var q = dq();
      var lane = (q && typeof q.getFocus === 'function') ? q.getFocus() : null;
      if (lane && canon[lane]) return canon[lane];
      return canon.classic || '/collections/all';
    }

    /* GBP → live-currency display (HGN_DROP_PRICES / HGN_KIT_RETAILS
       are GBP canonical; never a hardcoded £ in shipped copy). */
    function fmtGbp(v) {
      var n = (typeof v === 'number' && isFinite(v)) ? v : 0;
      try {
        if (window.HGN && typeof window.HGN.formatLive === 'function' &&
            typeof window.HGN.activeCurrencyKey === 'function') {
          return window.HGN.formatLive(n, window.HGN.activeCurrencyKey());
        }
      } catch (e) {}
      return '£' + n.toFixed(2);
    }

    /* Lane for the pre-queue pitch — the locked lane first, else the
       dominant tier among queued items (legacy mixed pre-queues). */
    function pitchLane(queue) {
      var q = dq();
      var lane = (q && typeof q.getFocus === 'function') ? q.getFocus() : null;
      if (lane) return lane;
      var counts = {};
      queue.forEach(function (it) {
        if (it.tier) counts[it.tier] = (counts[it.tier] || 0) + 1;
      });
      var best = null;
      DROP_TIERS.forEach(function (t) {
        if (counts[t] && (!best || counts[t] > counts[best])) best = t;
      });
      return best;
    }

    /* R3 — pre-queue exposition: the savings pitch in the kit
       building-hint presentation style (projected math: per-box price
       vs box-count × single-design retail from HGN_KIT_RETAILS, all
       GBP canonical through formatLive) + the gifts line. Empty
       string when no lane or no price is resolvable. */
    function preQueuePitchHtml(queue) {
      var lane = pitchLane(queue);
      if (!lane) return '';
      var prices = window.HGN_DROP_PRICES || {};
      var priceGbp = prices[lane];
      if (typeof priceGbp !== 'number' || !(priceGbp > 0)) return '';
      var retails = (window.HGN_KIT_RETAILS && window.HGN_KIT_RETAILS[lane]) || {};
      var designGbp = (typeof retails.design === 'number') ? retails.design : 0;
      var count = tierCount(lane);
      var noun = LANE_NOUN[lane] || 'designs';
      var line;
      if (designGbp > 0) {
        var retailGbp = count * designGbp;
        var savings = Math.max(0, retailGbp - priceGbp);
        var pct = retailGbp > 0 ? Math.round((savings / retailGbp) * 100) : 0;
        line = escapeHtml(dropCopy('preQueuePitch',
          'Every box: {count} {noun} for {price} — worth {retail} buying separately. You save {savings} (~{pct}%).'))
          .split('{count}').join('<strong>' + count + '</strong>')
          .split('{noun}').join(escapeHtml(noun))
          .split('{price}').join('<strong>' + escapeHtml(fmtGbp(priceGbp)) + '</strong>')
          .split('{retail}').join('<strong>' + escapeHtml(fmtGbp(retailGbp)) + '</strong>')
          .split('{savings}').join('<strong>' + escapeHtml(fmtGbp(savings)) + '</strong>')
          .split('{pct}').join(String(pct));
      } else {
        /* No retail basis broadcast — price-only claim. */
        line = escapeHtml(dropCopy('preQueuePitchNoRetail',
          'Every box: {count} {noun} for {price} — around 25% less than buying the same items separately.'))
          .split('{count}').join('<strong>' + count + '</strong>')
          .split('{noun}').join(escapeHtml(noun))
          .split('{price}').join('<strong>' + escapeHtml(fmtGbp(priceGbp)) + '</strong>');
      }
      return '<p class="hgn-side-cart__drop-pitch">' + line + '</p>' +
        '<p class="hgn-side-cart__drop-note">' +
          escapeHtml(dropCopy('preQueueGifts',
            'Plus free gifts in each of your first three boxes — and free shipping every time.')) +
        '</p>';
    }

    /* ───── Boundary dates ─────
       Boundary k (0-based, before queue index k × count) projects to
       nextExpectedAt + k × frequencyWeeks. Formatted "14 Sep" in the
       shopper's locale; blank (marker still renders, undated) when
       the subscriber row carries no usable date. */
    function subscriberField(sub, camel, snake) {
      if (!sub) return null;
      return sub[camel] != null ? sub[camel] : sub[snake];
    }
    function boundaryDate(sub, k) {
      var nextRaw = subscriberField(sub, 'nextExpectedAt', 'next_expected_at');
      var freq = parseInt(subscriberField(sub, 'frequencyWeeks', 'frequency_weeks'), 10);
      if (!nextRaw || !isFinite(freq) || freq <= 0) return '';
      var base = new Date(nextRaw);
      if (isNaN(base.getTime())) return '';
      var d = new Date(base.getTime() + k * freq * 7 * 24 * 60 * 60 * 1000);
      try {
        return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
      } catch (e) {
        return d.getDate() + '/' + (d.getMonth() + 1);
      }
    }
    function boundaryLabel(sub, k) {
      var date = boundaryDate(sub, k);
      var tpl;
      if (k === 0) {
        tpl = dropCopy('boundaryNext', date ? 'Your next Nail Drop · ~{date}' : 'Your next Nail Drop');
      } else {
        tpl = dropCopy('boundaryLater', date ? 'Nail Drop +{n} · ~{date}' : 'Nail Drop +{n}');
      }
      return String(tpl)
        .split('{n}').join(String(k))
        .split('{date}').join(date);
    }

    /* ───── Row / section builders ─────
       `offLane` (fix F4, pre-queue only): legacy scratch items whose
       tier doesn't match the locked lane render greyed with an honest
       badge — the sync merge will skip them, so they must never look
       like they're joining this Nail Drop. */
    var DROP_LANE_SHORT = { classic: 'Classic', gels: 'Gel', 'press-ons': 'Press-On' };
    function rowHtml(item, draggable, offLane) {
      var thumb = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">'
        : '';
      var stock = stockMap[item.variantId];
      var oosHtml = (stock && stock.inStock === false)
        ? '<span class="hgn-side-cart__drop-oos">' + escapeHtml(dropCopy('oosBadge', 'Out of stock — we’ll skip and revisit')) + '</span>'
        : '';
      var offLaneHtml = '';
      if (offLane) {
        offLaneHtml = '<span class="hgn-side-cart__drop-offlane">' +
          escapeHtml(dropCopy('offLaneBadge', '{tier} — not in this Nail Drop')
            .split('{tier}').join(DROP_LANE_SHORT[item.tier] || 'Other range')) +
        '</span>';
      }
      var dragHtml = draggable
        ? '<button type="button" class="hgn-side-cart__drop-drag" data-hgn-drop-drag aria-label="Drag to reorder ' + escapeHtml(item.title || 'this design') + '">' +
            '<svg width="12" height="14" viewBox="0 0 12 16" fill="currentColor" aria-hidden="true">' +
              '<circle cx="3.5" cy="3" r="1.4"/><circle cx="8.5" cy="3" r="1.4"/>' +
              '<circle cx="3.5" cy="8" r="1.4"/><circle cx="8.5" cy="8" r="1.4"/>' +
              '<circle cx="3.5" cy="13" r="1.4"/><circle cx="8.5" cy="13" r="1.4"/>' +
            '</svg>' +
          '</button>'
        : '<span class="hgn-side-cart__drop-drag" aria-hidden="true" style="visibility:hidden;"></span>';
      return '<div class="hgn-side-cart__drop-row' + (offLane ? ' is-off-lane' : '') + '" data-hgn-drop-row data-variant-id="' + escapeHtml(item.variantId) + '">' +
        dragHtml +
        '<span class="hgn-side-cart__drop-thumb">' + thumb + '</span>' +
        '<div class="hgn-side-cart__drop-row-info">' +
          '<p class="hgn-side-cart__drop-row-title">' + escapeHtml(item.title || '') + '</p>' +
          offLaneHtml +
          (cartVariantIds[String(item.variantId)]
            ? '<span class="hgn-side-cart__drop-offlane hgn-side-cart__drop-dupe">' +
                escapeHtml(dropCopy('dupeBadge', 'Also in your bag as a one-off purchase')) + '</span>'
            : '') +
          oosHtml +
        '</div>' +
        '<button type="button" class="hgn-side-cart__drop-remove" data-hgn-drop-remove data-variant-id="' + escapeHtml(item.variantId) + '" aria-label="Remove ' + escapeHtml(item.title || 'this design') + ' from your Nail Drop">' +
          '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" aria-hidden="true">' +
            '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
      '</div>';
    }

    function headHtml(eyebrow, title, count, open) {
      return '<button type="button" class="hgn-side-cart__drop-head" data-hgn-drop-head aria-expanded="' + (open ? 'true' : 'false') + '">' +
        '<span class="hgn-side-cart__drop-eyebrow">' + escapeHtml(eyebrow) + '</span>' +
        '<span class="hgn-side-cart__drop-count">' + count + '</span>' +
        '<svg class="hgn-side-cart__drop-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '<span class="hgn-side-cart__drop-title">' + escapeHtml(title) + '</span>' +
      '</button>';
    }

    function subscriberSectionHtml(state, queue) {
      var sub = state.subscriber;
      var tier = sub && sub.tier;
      var count = tierCount(tier);
      var open = manualOpen !== 'closed';
      var title = TIER_LABEL[tier] || dropCopy('cartTitle', 'Your Nail Drop');

      var bodyRows = '';
      /* Fix F4: honest notice when the pre-queue merge skipped
         off-lane saves (worker `tierRejected`). */
      if (tierRejectedNotice > 0) {
        bodyRows += '<p class="hgn-side-cart__drop-note hgn-side-cart__drop-note--rejected">' +
          escapeHtml(dropCopy('syncRejectedNotice', '{n} saved design{s} weren’t in your lane and didn’t join this Nail Drop.')
            .split('{n}').join(String(tierRejectedNotice))
            .split('{s}').join(tierRejectedNotice === 1 ? '' : 's')) +
        '</p>';
      }
      if (queue.length === 0) {
        bodyRows += '<p class="hgn-side-cart__drop-note">' +
          escapeHtml(dropCopy('emptyLine', 'Add designs from any collection and we’ll queue them for your next Nail Drop.')) +
        '</p>';
      } else {
        /* R3: the subscriber's surface IS the queue — lead with the
           reorder affordance, never a "start" CTA. */
        if (queue.length > 1) {
          bodyRows += '<p class="hgn-side-cart__drop-note hgn-side-cart__drop-note--hint">' +
            escapeHtml(dropCopy('dragHint', 'Drag to change the order you’ll receive them')) +
          '</p>';
        }
        queue.forEach(function (item, i) {
          if (i % count === 0) {
            var k = i / count;
            bodyRows += '<div class="hgn-side-cart__drop-boundary" aria-hidden="true">' +
              escapeHtml(boundaryLabel(sub, k)) +
            '</div>';
          }
          bodyRows += rowHtml(item, queue.length > 1);
        });
      }

      return '<section class="hgn-side-cart__drop" data-hgn-drop-section aria-label="Your Nail Drop queue">' +
        headHtml(dropCopy('cartEyebrow', 'Up Next'), title, queue.length, open) +
        '<div class="hgn-side-cart__drop-body">' +
          '<div class="hgn-side-cart__drop-rows" data-hgn-drop-rows>' + bodyRows + '</div>' +
          '<div class="hgn-side-cart__drop-foot">' +
            '<a class="hgn-side-cart__drop-browse" href="' + escapeHtml(browseUrl()) + '">' +
              '<span>' + escapeHtml(dropCopy('browseLabel', 'Browse designs')) + '</span>' +
              '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true">' +
                '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</a>' +
          '</div>' +
        '</div>' +
      '<div class="hgn-side-cart__drop-manage" data-hgn-drop-manage>' +
        '<button type="button" class="hgn-side-cart__drop-manage-head" data-hgn-dm-toggle aria-expanded="false" style="width:100%;display:flex;align-items:center;justify-content:space-between;background:none;border:0;border-top:1px solid rgba(15,13,11,.12);padding:12px 0;font:inherit;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;color:inherit;">' +
          '<span>Manage my plan</span>' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="hgn-side-cart__drop-manage-body" data-hgn-drop-manage-mount hidden style="padding:4px 0 14px;"></div>' +
      '</div>' +
      '</section>';
    }

    function preQueueSectionHtml(queue) {
      var open = manualOpen !== 'closed';
      var q = dq();
      var lane = (q && typeof q.getFocus === 'function') ? q.getFocus() : null;
      var rows = '';
      queue.forEach(function (item) {
        var offLane = !!(lane && item.tier && item.tier !== lane);
        rows += rowHtml(item, true, offLane); /* Matt 2026-07-24: pre-queue drags too — reorder parity on every surface */
      });
      return '<section class="hgn-side-cart__drop" data-hgn-drop-section aria-label="Your Nail Drop pre-queue">' +
        headHtml(dropCopy('cartEyebrow', 'Up Next'), dropCopy('preQueueTitle', 'Saved for your first Nail Drop'), queue.length, open) +
        '<div class="hgn-side-cart__drop-body">' +
          preQueuePitchHtml(queue) +
          '<div class="hgn-side-cart__drop-rows" data-hgn-drop-rows>' + rows + '</div>' +
          '<div class="hgn-side-cart__drop-foot">' +
            '<a class="hgn-side-cart__drop-cta" href="' + escapeHtml(wizardUrl()) + '" data-hgn-drop-wizard-cta>' +
              '<span>' + escapeHtml(dropCopy('preQueueCta', 'Start your Nail Drop')) + '</span>' +
              '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" aria-hidden="true">' +
                '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</a>' +
          '</div>' +
        '</div>' +
      '</section>';
    }

    function emptySectionHtml() {
      var open = manualOpen !== 'closed';
      return '<section class="hgn-side-cart__drop" data-hgn-drop-section aria-label="Your Nail Drop">' +
        headHtml(dropCopy('cartEyebrow', 'Up Next'), dropCopy('cartTitle', 'Your Nail Drop'), 0, open) +
        '<div class="hgn-side-cart__drop-body">' +
          '<p class="hgn-side-cart__drop-note">' +
            escapeHtml(dropCopy('emptyLine', 'Add designs from any collection and we’ll queue them for your next Nail Drop.')) +
          '</p>' +
          '<div class="hgn-side-cart__drop-foot">' +
            '<a class="hgn-side-cart__drop-browse" href="' + escapeHtml(browseUrl()) + '">' +
              '<span>' + escapeHtml(dropCopy('browseLabel', 'Browse designs')) + '</span>' +
              '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true">' +
                '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</a>' +
          '</div>' +
        '</div>' +
      '</section>';
    }

    /* ───── Render ───── */
    function render() {
      var q = dq();
      /* Availability guard — flag off + no tester = this section does
         not exist. Bail before ANY other work. */
      if (!q || !dropAvailable()) { listEl.innerHTML = ''; return; }
      var state = (typeof q.getCachedState === 'function') ? q.getCachedState() : null;
      var queue = q.getQueue();
      var html = '';
      if (state && state.subscriber) {
        html = subscriberSectionHtml(state, queue);
      } else if (queue.length > 0) {
        html = preQueueSectionHtml(queue);
      } else if (dropModeOn()) {
        html = emptySectionHtml();
      }
      listEl.innerHTML = html;
      if (queue.length > 0) ensureCartLines();
      if (html && state && state.subscriber) {
        refreshStockBadges(queue);
        /* P6: plan-management concertina (shared component, portal
           parity). Mount lazily on first open. */
        var manageHead = listEl.querySelector('[data-hgn-dm-toggle]');
        var manageBody = listEl.querySelector('[data-hgn-drop-manage-mount]');
        if (manageHead && manageBody) {
          manageHead.addEventListener('click', function () {
            var open = manageBody.hidden;
            manageBody.hidden = !open;
            manageHead.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open && window.HGN && window.HGN.dropManage) {
              window.HGN.dropManage.mount(manageBody, { compact: true });
            }
          });
        }
      }
    }

    /* ───── Stock badges ─────
       One batched stock-check per queue snapshot (dropQueue caches
       identical id-sets for 60s, so render storms stay at one call).
       Badges annotate in place — no re-render loop. */
    function refreshStockBadges(queue) {
      var q = dq();
      if (!q || typeof q.stockCheck !== 'function' || queue.length === 0) return;
      var ids = queue.map(function (it) { return it.variantId; });
      q.stockCheck(ids).then(function (map) {
        if (!map) return;
        stockMap = map;
        /* Re-render only if the section is still showing the same
           queue (cheap check: row count matches). */
        var rows = listEl.querySelectorAll('[data-hgn-drop-row]');
        rows.forEach(function (row) {
          var vid = row.getAttribute('data-variant-id');
          var stock = stockMap[vid];
          var info = row.querySelector('.hgn-side-cart__drop-row-info');
          if (!info) return;
          var badge = info.querySelector('.hgn-side-cart__drop-oos');
          var oos = !!(stock && stock.inStock === false);
          if (oos && !badge) {
            var span = document.createElement('span');
            span.className = 'hgn-side-cart__drop-oos';
            span.textContent = dropCopy('oosBadge', 'Out of stock — we’ll skip and revisit');
            info.appendChild(span);
          } else if (!oos && badge) {
            badge.parentNode.removeChild(badge);
          }
        });
      });
    }

    /* ───── Lazy hydration ─────
       Fetch subscriber state only when there's a reason to believe
       this shopper participates: drop mode on, a local pre-queue, or
       the participation crumb from a previous subscriber hit.
       dropQueue.getSubscriberState() additionally no-ops for guests
       and when Drop is unavailable — logged-in NON-participants are
       never probed on cart open. */
    var hydrated = false;
    function maybeHydrate() {
      if (hydrated) return;
      var q = dq();
      if (!q || !dropAvailable()) return;
      var interested = dropModeOn() ||
        (typeof q.queueLength === 'function' && q.queueLength() > 0) ||
        (typeof q.hasParticipantCrumb === 'function' && q.hasParticipantCrumb());
      if (!interested) return;
      hydrated = true;
      q.getSubscriberState().then(function () { render(); });
    }

    /* ───── Drag-and-drop reorder (pointer events, no library) ─────
       Grab the handle → the row lifts and live-reorders against its
       sibling rows' midpoints while the pointer moves; release →
       collect the DOM order → dropQueue.reorder() (optimistic local
       apply + PUT /api/drop/queue/reorder), whose hgn:drop:change
       re-render restores the boundary markers around the new order. */
    var drag = null;
    listEl.addEventListener('pointerdown', function (e) {
      var handle = e.target.closest('[data-hgn-drop-drag]');
      if (!handle || handle.tagName !== 'BUTTON') return;
      var row = handle.closest('[data-hgn-drop-row]');
      var rowsWrap = handle.closest('[data-hgn-drop-rows]');
      if (!row || !rowsWrap) return;
      e.preventDefault();
      drag = { row: row, wrap: rowsWrap, pointerId: e.pointerId, moved: false };
      row.classList.add('is-dragging');
      rowsWrap.classList.add('is-drag-active'); /* W6c drop-zone highlight */
      try { handle.setPointerCapture(e.pointerId); } catch (err) {}
    });
    listEl.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.pointerId) return;
      e.preventDefault();
      drag.moved = true;
      var rows = Array.prototype.slice.call(drag.wrap.querySelectorAll('[data-hgn-drop-row]'));
      var target = null;
      var before = false;
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (r === drag.row) continue;
        var rect = r.getBoundingClientRect();
        var mid = rect.top + rect.height / 2;
        if (e.clientY < mid) { target = r; before = true; break; }
        target = r; before = false;
      }
      if (!target) return;
      if (before) {
        if (target.previousElementSibling !== drag.row) {
          drag.wrap.insertBefore(drag.row, target);
        }
      } else if (target.nextElementSibling !== drag.row) {
        drag.wrap.insertBefore(drag.row, target.nextElementSibling);
      }
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.pointerId)) return;
      var row = drag.row;
      var wrap = drag.wrap;
      var moved = drag.moved;
      drag = null;
      row.classList.remove('is-dragging');
      wrap.classList.remove('is-drag-active'); /* W6c */
      if (!moved) return;
      var q = dq();
      if (!q) return;
      var orderedIds = Array.prototype.map.call(
        wrap.querySelectorAll('[data-hgn-drop-row]'),
        function (r) { return r.getAttribute('data-variant-id'); }
      ).filter(Boolean);
      q.reorder(orderedIds); // emits hgn:drop:change → re-render fixes boundaries
    }
    listEl.addEventListener('pointerup', endDrag);
    listEl.addEventListener('pointercancel', endDrag);

    /* ───── Delegated clicks: concertina head + remove ───── */
    listEl.addEventListener('click', function (e) {
      var head = e.target.closest('[data-hgn-drop-head]');
      if (head) {
        var nowOpen = head.getAttribute('aria-expanded') !== 'true';
        manualOpen = nowOpen ? 'open' : 'closed';
        render();
        return;
      }
      var rem = e.target.closest('[data-hgn-drop-remove]');
      if (rem) {
        var q = dq();
        var vid = rem.getAttribute('data-variant-id');
        if (q && vid) q.removeItem(vid); // emits hgn:drop:change → re-render
        return;
      }
    });

    /* ───── Subscriptions ───── */
    document.addEventListener('hgn:drop:change', function (e) {
      /* Fix F4: capture sync-local's lane-integrity skip count. */
      var d = e.detail || {};
      if (d.action === 'sync-local' && typeof d.tierRejected === 'number' && d.tierRejected > 0) {
        tierRejectedNotice = d.tierRejected;
      }
      render();
    });
    document.addEventListener('hgn:drop:focus:change', render);
    document.addEventListener('hgn:shop-mode:change', function () {
      maybeHydrate();
      render();
    });
    /* Currency-aware re-render — the pre-queue pitch formats GBP
       amounts via HGN.formatLive (same pattern as the kit IIFE). */
    document.addEventListener('shopify:currency:update', render);
    document.addEventListener('hgn:fx:update', render);
    /* Cart mutations re-sync the dupe badges (detail.cart carried by
       the side cart's own change event). */
    document.addEventListener('hgn:cart:change', function (e) {
      if (e.detail && e.detail.cart) { adoptCartLines(e.detail.cart); render(); }
    });
    /* Drawer open — hydrate (participants only, see maybeHydrate) and
       repaint so the section reflects any cross-page queue changes. */
    ['hgn:cart:open', 'cart:open'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        maybeHydrate();
        render();
      });
    });

    /* Scroll-to-drop handler — exact mirror of kit-build's
       scroll-to-build (same 220ms settle so the drawer's open
       animation finishes first). */
    document.addEventListener('hgn:side-cart:scroll-to-drop', function () {
      manualOpen = 'open';
      render();
      setTimeout(function () {
        var target = listEl.querySelector('[data-hgn-drop-section]') || listEl;
        if (!target) return;
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {}
      }, 220);
    });

    maybeHydrate();
    render();
  });
})();
